import { useAppDispatch, useAppSelector } from 'store/hook';
import ScrollableChipBar from 'components/ScrollableChipBar/ScrollableChipBar';
import { setSelectedTags } from 'store/sensorAnalysis.slice';
import useAppTheme from 'hooks/useAppTheme';
import { useTagData } from '../hooks/useTagData';

export const SelectedSensorList = () => {
  const { enableDarkTheme } = useAppTheme();
  const dispatch = useAppDispatch();
  const selectedTags = useAppSelector(
    (state) => state.sensorAnalysisReducer.selectedTags
  );

  const tags = useAppSelector(
    (state) => state.sensorAnalysisReducer.selectedAsset?.device?.tags ?? []
  );
  const { noDataTagAliases, tagAliases } = useTagData();

  const handleSelectTags = (tags: string[]) => {
    dispatch(setSelectedTags(tags));
  };

  const removeTag = (tagName: string) => {
    let updatedTags: string[] = [...selectedTags];
    const tagExists = selectedTags.find((item) => item === tagName);
    if (tagExists) {
      updatedTags = selectedTags.filter((item) => item !== tagName);
    } else {
      updatedTags = [...selectedTags, tagName];
    }
    handleSelectTags(updatedTags);
  };

  function handleClickTag(tagAlias: string) {
    const clickedTag = tags.find((item) => item.tagAlias === tagAlias);
    if (clickedTag) {
      removeTag(clickedTag.tagName);
    }
  }

  return (
    <>
      <ScrollableChipBar
        items={tagAliases}
        handleClick={handleClickTag}
        enableDarkTheme={enableDarkTheme}
        noDataItems={noDataTagAliases}
      />
    </>
  );
};

export default SelectedSensorList;
